// 담당자/이름 입력칸 자동완성용 — 명함관리 + 업체관리에 등록된 담당자를 먼저 보여준다.
// 호출할 때마다 서버에서 새로 읽으므로 기존 등록분과 이후 신규 등록분이 모두 반영된다.
import API from '../api';
import { parseManagerTitle } from './parseManagerTitle';

export async function loadPeople() {
  try {
    const r = await API.get('/companies/people-lookup');
    return (r.data || []).map(p => {
      if (p.source === 'company') {
        const { name, position } = parseManagerTitle(p.raw_name || '');
        return { name, position, department: '', phone: p.phone || '', company: p.company || '', source: 'company' };
      }
      return { name: p.name || '', position: p.position || '', department: p.department || '', phone: p.phone || '', company: p.company || '', source: 'card' };
    }).filter(p => p.name);
  } catch (e) { return []; }
}

const norm = (s) => String(s || '').toLowerCase().replace(/\s+/g, '').replace(/\(주\)|㈜|주식회사|\(유\)/g, '');

// 회사명이 있으면 그 회사 소속 인물을 우선(없으면 전체)
export function peopleFor(people, company) {
  const n = norm(company);
  const same = n ? people.filter(p => norm(p.company) === n) : [];
  return same.length ? same : people;
}

// 이름이 정확히 일치하는 인물 1명(명함관리 우선, 같은 회사 우선)
export function findPerson(people, name, company) {
  const t = String(name || '').trim();
  if (!t) return null;
  const hits = peopleFor(people, company).filter(p => p.name === t);
  return hits[0] || null;
}

export function personLabel(p) {
  return [p.company, p.department, p.position].filter(Boolean).join(' · ');
}
